var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnglish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4006_8563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.543 20C16.0658 20 20.543 15.5228 20.543 10C20.543 4.47715 16.0658 0 10.543 0C5.02012 0 0.542969 4.47715 0.542969 10C0.542969 15.5228 5.02012 20 10.543 20Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.61015 3.91187C1.82464 4.93386 1.23233 6.11179 0.887451 7.39144H6.08972L2.61015 3.91187Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1985 7.3914C19.8536 6.11179 19.2613 4.93386 18.4758 3.91187L14.9963 7.3914H20.1985Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.887451 12.6086C1.23237 13.8883 1.82468 15.0662 2.61015 16.0881L6.0896 12.6086H0.887451Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6311 2.06722C15.6091 1.28171 14.4313 0.689404 13.1516 0.344482V5.54671L16.6311 2.06722Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.45483 17.9328C5.47683 18.7183 6.65476 19.3106 7.93437 19.6556V14.4534L4.45483 17.9328Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.93433 0.344482C6.65472 0.689404 5.47679 1.28171 4.45483 2.06718L7.93433 5.54667V0.344482Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1516 19.6556C14.4312 19.3106 15.6092 18.7183 16.6311 17.9329L13.1516 14.4534V19.6556Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9963 12.6086L18.4758 16.0882C19.2613 15.0662 19.8536 13.8883 20.1985 12.6086H14.9963Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4583 8.69566H11.8474H11.8473V0.0846484C11.4204 0.0290625 10.985 0 10.543 0C10.1008 0 9.66559 0.0290625 9.23863 0.0846484V8.69559V8.69563H0.627617C0.572031 9.12262 0.542969 9.55793 0.542969 10C0.542969 10.4421 0.572031 10.8774 0.627617 11.3043H9.23855H9.23859V19.9154C9.66559 19.9709 10.1008 20 10.543 20C10.985 20 11.4204 19.971 11.8473 19.9154V11.3044V11.3044H20.4583C20.5139 10.8774 20.543 10.4421 20.543 10C20.543 9.55793 20.5139 9.12262 20.4583 8.69566Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1516 12.6087L17.614 17.071C17.8192 16.8659 18.015 16.6514 18.2018 16.429L14.3814 12.6086H13.1516V12.6087Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.93431 12.6086H7.93423L3.47192 17.0709C3.67708 17.2762 3.89157 17.472 4.11392 17.6588L7.93431 13.8383V12.6086Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.93419 7.39142V7.39134L3.47185 2.92896C3.26661 3.13411 3.07083 3.3486 2.88403 3.57095L6.70446 7.39138H7.93419V7.39142Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1516 7.39126L17.614 2.92884C17.4088 2.7236 17.1943 2.52782 16.972 2.34106L13.1516 6.16149V7.39126Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4006_8563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.542969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/english.59ebd66181a5a75c3417436094a627e9.svg";
export { ForwardRef as ReactComponent };